import { API_URLS, S3_CONFIG } from '../config/apiConfig';
import { makeAuthenticatedRequest } from '../apiUtils';
import { handleApiError } from '../config/errorHandling';
import { S3_JSON_KEY } from '../filePathUtils';

export const fetchS3DataSU = async (_idToken?: string): Promise<string[]> => {
  try {
    const s3Response = await makeAuthenticatedRequest(
      `${API_URLS.S3_DATA}?bucket=${encodeURIComponent(S3_CONFIG.BUCKET_2)}&key=${encodeURIComponent(S3_JSON_KEY)}`,
    );

    const responseText = await s3Response.text();
    // console.log('Full S3 API response:', responseText);

    if (!s3Response.ok) {
      throw new Error(`S3 API error! status: ${s3Response.status}`);
    }

    const parsedResponse = JSON.parse(responseText);
    const s3Data = JSON.parse(parsedResponse.body);
    const s3FileUrl = s3Data.url;

    const fileResponse = await fetch(s3FileUrl);
    if (!fileResponse.ok) {
      throw new Error(`File fetch error! status: ${fileResponse.status}`);
    }

    const fileData: string[] = await fileResponse.json();
    return fileData; // Ensure this returns a string array or appropriate type
  } catch (error) {
    handleApiError(error, "Error fetching S3 data");
    return []; // Return an empty array in case of error
  }
};
